import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, hasOne } from '@apexdesigner/schema-tools';

export const user = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    email: z.string().describe('Email - User email address'),

    firstName: z
      .string()
      .nullable()
      .optional()
      .describe("The user's first name."),

    lastName: z
      .string()
      .nullable()
      .optional()
      .describe("The user's last name."),

    phone: z
      .string()
      .nullable()
      .optional()
      .describe("The user's phone number."),

    roleAssignments: hasMany('RoleAssignment', 'userId'),

    userTasks: hasMany('UserTask', 'userId'),

    myUserTasks: hasMany('MyUserTask', 'userId'),

    candidate: hasOne('Candidate', 'userId'),

    trainingClasses: hasMany('TrainingClass', 'instructorId'),

    interviews: hasMany('Interview', 'interviewerId'),

    sentCorrespondenceItems: hasMany('CorrespondenceItem', 'senderId'),

    receivedCorrespondenceItems: hasMany('CorrespondenceItem', 'recipientId'),
  })
  .describe('Authenticated user identified by email address.')
  .as('User');

export { user as userSchema };
